import React from 'react'
import { Fab } from '@mui/material'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'

const BackButton: React.FC<{ onClick: () => void }> = ({ onClick }) => {
  return (
    <Fab
      onClick={onClick}
      aria-label='Volver'
      variant='extended'
      size='medium'
      style={{
        borderRadius: '12px',
        height: '50px',
        minWidth: '110px',
        paddingLeft: '10px',
        paddingRight: '14px',
        zIndex: 1,
        backgroundColor: 'transparent',
        border: '1px solid #E0E0E0',
        boxShadow: 'none',
        fontSize: '14px',
        fontWeight: 500,
        color: '#666',
        gap: '2px',
        textTransform: 'none',
        marginLeft: '2%',
        marginTop: '2%',
        alignSelf: 'flex-start'
      }}
    >
      <ArrowBackIcon style={{ fontSize: 18 }} />
      Volver
    </Fab>
  )
}

export default BackButton
